import { serviceById } from '@squadlab/contracts/catalogue';

/**
 * The one place this package learns where the Command Center lives.
 *
 * It is a separate module from the component on purpose. Resolving the URL goes
 * through the Zod-parsed catalogue, which is free for a bundled service (it already
 * ships `@squadlab/contracts`) and would be ~70KB of dead weight on a static console
 * that only needs one string. The static build injects the same value at generation
 * time instead — read from the same JSON (see `scripts/gen-standalone.mjs`), so
 * there is still exactly one source of truth.
 */

/** The catalogue id of the front door. */
export const COMMAND_CENTER_SERVICE_ID = 'command-center';

/**
 * The Command Center's canonical URL, from the single source of truth
 * (`packages/contracts/src/catalogue/service-urls.json`). Never hard-code it.
 *
 * Throws if the row is missing: that is a committed-config bug, caught by this
 * package's own unit test long before a service could boot without it, and a dead
 * link is a worse answer than a loud one.
 */
export function commandCenterHref(): string {
  const entry = serviceById(COMMAND_CENTER_SERVICE_ID);
  if (!entry) {
    throw new Error(
      `service catalogue has no "${COMMAND_CENTER_SERVICE_ID}" row — @squadlab/os-chrome cannot resolve the front door`,
    );
  }
  return entry.url;
}
